module.exports = __webpack_public_path__ + "img/mufg.455d4ff5.svg";